<div class="sticky-list-header">
    <curafida-search-and-button
        (openFilterModal)="openFilterModal()"
        (updates)="processFilterUpdate($event)"
        (setButtonAction)="buttonClick($event)"
        [buttonIcon]="'add'"
        [buttonList]="buttonList()"
        [filterLength]="filterCount()"
        [hideButton]="!mayCreateTask()"
        [hideFilter]="false"
        [hideSearch]="false">
    </curafida-search-and-button>
    @if (segmentListTask?.length > 0 && patientTaskTableConfig.list !== null) {
        <curafida-segment
            (sendSegmentType)="setTaskSegmentType($event)"
            [maxMainListItem]="7"
            [segmentList]="segmentListTask"
            [segmentValue]="displayedTaskType()"
            class="segment-list">
        </curafida-segment>
    }
</div>
<div class="full-width">
    @if (displayedTaskType() !== SegmentType.PLAN) {
        <curafida-table
            (openDetail)="openTaskDetailPage($event?.id)"
            (tableEvent)="processTableEvent($event)"
            [isLoading]="isLoading()"
            [listTableConfig]="patientTaskTableConfig">
        </curafida-table>
    }
    @if (displayedTaskType() === SegmentType.PLAN) {
        <div>
            <lib-patient-task-plan-list
                [hideEditButtons]="userRoles() | containsNot: UserRoles.write_task_plan"
                [user]="patient()"></lib-patient-task-plan-list>
        </div>
    }
</div>
